import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductSpecification extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  /**
   * Updates the specification content (e.g. SKU when shown for non-B2B).
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpec = event.detail.data.html.querySelector('product-specification');

    if (!newSpec) {
      this.innerHTML = '';
      this.hidden = true;
      return;
    }

    this.hidden = false;
    morph(this, newSpec, { childrenOnly: true });
  };
}

if (!customElements.get('product-specification')) {
  customElements.define('product-specification', ProductSpecification);
}
